import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const CareerIncome = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<h3>소득정보</h3>
					<ul className="tab-round mt_20">
						<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>2019년</li>
						<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>2020년</li>
						<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>2021년</li>
					</ul>
					<div className={`${styles["result-title"]} mt_30`}>
						올해 소득은<br /><strong>3,500만원</strong>이네요!
					</div>
					<hr className="my_30" />
					<ul className="list-item" style={{ fontSize: "1.4rem" }}>
						<li>
							<span>고지총액</span>
							<span>2,000,000 원</span>
						</li>
						<li>
							<span>납부총액</span>
							<span>0 원</span>
						</li>
						<li className="block">
							<span>연말정산</span>
							<div className={`${styles["detail-box"]} mt_10 mb_20`}>
								<ul className="list-item" style={{ fontSize: "1.4rem" }}>
									<li>
										<span>건강보험료</span>
										<span>0 원</span>
									</li>
									<li>
										<span>장기요양보험료</span>
										<span>0 원</span>
									</li>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div className="padding">
				<h3>건강 ・ 장기요양보험료 납부내역</h3>
				<div className={`${styles["result-title"]} mt_30`}>
					9월 고지금액은 <strong style={{ color: "#333" }}>210,000원</strong>이며<br />
					현재 <strong>0%</strong> 납부되었네요!
				</div>
				<ul className={`${styles["pay-graph"]} mt_40 px_30 pt_40 no-scroll`}>
					<li>
						<div className={styles["bar-group"]}>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
						</div>
						<p>4월</p>
					</li>
					<li>
						<div className={styles["bar-group"]}>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
						</div>
						<p>5월</p>
					</li>
					<li>
						<div className={styles["bar-group"]}>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
						</div>
						<p>6월</p>
					</li>
					<li>
						<div className={styles["bar-group"]}>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
						</div>
						<p>7월</p>
					</li>
					<li>
						<div className={styles["bar-group"]}>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
						</div>
						<p>8월</p>
					</li>
					<li>
						<div className={styles["bar-group"]}>
							<div className={styles.bar}>
								<span style={{ height: "100%" }} />
							</div>
							<div className={`${styles.bar} ${styles.today}`}>
								<span style={{ height: "20%" }} />
							</div>
						</div>
						<p>9월</p>
						<div className={styles.info}>
							<span>0%납부</span>
							<i className={`${styles["icon_arrow"]} icon`} />
						</div>
					</li>
				</ul>
				<div className="flex-justify_center">
					<div className="color-box mt_20">
						<ul className="color-title">
							<li className="sky-blue">고지금액</li>
							<li className="blue">납부금액</li>
						</ul>
					</div>
				</div>
				<div className="swiper-guide mt_30">
					<i className="icon icon_swiper_arrow mr_10" />
					<span>그래프를 좌우로 스와이프 해보세요.</span>
				</div>
			</div>
		</div>
	)
}

export default CareerIncome
